<template>
  <div>
    <template v-if="!loading">

      <b-row align-v="center">
        <b-col lg="4">
          <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
          <h3 class="h3-semibold-black mb-5">Vuoi ricevere una nostra offerta personalizzata per?</h3>
        </b-col>
        <b-col lg="6" offset-lg="2">
          <b-row>
            <b-col cols="6">
              <div class="config-button-element" @click="setPropertyType('casa')">
                <i class="sgri-casa-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">Casa</div>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="config-button-element" @click="setPropertyType('impresa')">
                <i class="sgri-impresa-2-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">Impresa</div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </template>
  </div>
</template>

<script>
export default {
  name: 'Step-1',
  data() {
    return {
      thisStep: 1,
      localOptions: null,
      loading: true,
      webPath: process.env.VUE_APP_WEB_PATH,
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    }
  },
  created() {
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};

    if(typeof this.localOptions.comune == 'undefined' || this.localOptions.comune == null)
      this.$router.push({name: 'step-comune'})
    else
      this.checkComune();
  },
  methods: {
    checkComune() {
      let that = this;
      that.loading = true;
      let comune = that.localOptions.comune;
      that.axios.get(that.webPath + 'wp-admin/admin-ajax.php', {
        params: {
          action: 'check-comune',
          query: comune,
        }
      })
          .then(response => {
            if (!response.data.success) {
              window.location.replace(response.data.redirecUrl);
            } else {
              that.loading = false;
              this.trackFbViewContent('configuratore', 'step-1');
            }
          })
          .catch(error => {
            console.log('error', error);
          })

    },

    setPropertyType(type) {
      this.localOptions.propertyType = type;
      let steps = type == 'impresa' ? 4 : 3;
      let nextStep = this.thisStep + 1;
      let realNextStep = type == 'impresa' ? 2 : 2;
      this.$emit('changeSteps',steps);
      this.$emit('nextStep',nextStep, realNextStep, this.localOptions)

    },
  },
}
</script>

<style scoped lang="scss">
</style>